import {
  Button,
  ButtonGroup,
  FormControlSizes,
  HStack,
  MixpanelEvent,
  MixpanelEventProperty,
  Toggle,
  useMixpanel,
} from '@talos/kyoko';
import { useMarketSelectorContext } from '../MarketSelectorContext';

export const MarketSelectorBlotterActionItems = () => {
  const {
    selectionsSet,
    unselectAll,
    selectAll,
    showCredentialsOnlyToggle,
    credentialsOnly,
    setCredentialsOnly,
    isNarrow,
  } = useMarketSelectorContext();
  const mixpanel = useMixpanel();

  const handleCredentialsOnlyChange = (checked: boolean) => {
    mixpanel.track(MixpanelEvent.ToggleCredentialsOnly, { [MixpanelEventProperty.Enabled]: checked });
    setCredentialsOnly(checked);
  };

  const handleSelectAll = () => {
    mixpanel.track(MixpanelEvent.UpdateMarketSelection, {
      [MixpanelEventProperty.Method]: 'SelectAll',
    });
    selectAll();
  };

  const handleClearAll = () => {
    mixpanel.track(MixpanelEvent.UpdateMarketSelection, {
      [MixpanelEventProperty.Method]: 'ClearAll',
    });
    unselectAll();
  };

  return (
    <HStack gap="spacing8">
      {showCredentialsOnlyToggle && !isNarrow && (
        <Toggle
          label="Credentials Only"
          checked={credentialsOnly}
          onChange={handleCredentialsOnlyChange}
          tooltip="If enabled, markets without a credentialed market account set up will be hidden in the market selector."
          size={FormControlSizes.Small}
          data-testid="credentials-only-toggle"
        />
      )}
      <ButtonGroup size={FormControlSizes.Small}>
        {isNarrow && (
          <Button onClick={handleSelectAll} data-testid="market-selector-blotter-select-all">
            Select All
          </Button>
        )}
        <Button
          disabled={selectionsSet.size === 0}
          onClick={handleClearAll}
          data-testid="market-selector-blotter-clear"
        >
          Clear{!isNarrow ? ' All' : ''}
        </Button>
      </ButtonGroup>
    </HStack>
  );
};
